import { Fragment } from "react";
import { Link } from "react-router-dom";

const PATHS = ["/prenota-visita-parodontale", "/igiene-gbt", "/test-gengive", "/paura-del-dentista", "/prima-visita", "/blog"];
const TOKEN = new RegExp(`(\\*\\*[^*]+\\*\\*|${PATHS.join("|")})`, "g");

const Inline = ({ text }) =>
  text.split(TOKEN).map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) return <strong key={i} className="font-semibold">{part.slice(2, -2)}</strong>;
    if (PATHS.includes(part)) return <Link key={i} to={part} className="underline underline-offset-2 decoration-[#3E6B48]/50 text-[#1B3B28] font-medium">{part}</Link>;
    return <Fragment key={i}>{part}</Fragment>;
  });

export const ChatText = ({ text }) => {
  const blocks = text.split(/\n{2,}/);
  return blocks.map((b, i) => {
    const lines = b.split("\n");
    if (lines.every((l) => /^\s*[-•]\s/.test(l))) {
      return (
        <ul key={i} className="list-disc pl-4 space-y-1 my-1.5">
          {lines.map((l, j) => <li key={j}><Inline text={l.replace(/^\s*[-•]\s/, "")} /></li>)}
        </ul>
      );
    }
    return <p key={i} className="my-1.5 first:mt-0 last:mb-0">{lines.map((l, j) => <Fragment key={j}>{j > 0 && <br />}<Inline text={l} /></Fragment>)}</p>;
  });
};
